import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import PillGroup from 'components/PillGroup';

import { SCHEDULE_FILTER_KEY } from './ScheduleFilterChips.constants';
import { getVisibleScheduleFilterOptions } from './ScheduleFilterChips.helpers';

const SCHEDULE_FILTER_KEY_VALUES = Object.values(SCHEDULE_FILTER_KEY);

function ScheduleFilterChips({ className, counts, hasSpotManagePermission, isManualStudio, selectedKey, onChange }) {
  const { formatMessage } = useIntl();
  const options = getVisibleScheduleFilterOptions({
    counts,
    formatMessage,
    hasSpotManagePermission,
    isManualStudio,
  });

  if (options.length === 0) {
    return null;
  }

  return <PillGroup className={className} options={options} value={selectedKey} onChange={onChange} />;
}

ScheduleFilterChips.propTypes = {
  className: PropTypes.string,
  counts: PropTypes.shape({
    activeClasses: PropTypes.number,
    disabledClasses: PropTypes.number,
    withClientsWaiting: PropTypes.number,
    withNewClients: PropTypes.number,
    withReservations: PropTypes.number,
  }),
  hasSpotManagePermission: PropTypes.bool,
  isManualStudio: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  selectedKey: PropTypes.oneOf(SCHEDULE_FILTER_KEY_VALUES),
};

export default ScheduleFilterChips;
